import colors from '../colors.js';
var he = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
export { he as default };
//# sourceMappingURL=Set3.js.map
